import {
    isCableCrossSellingItemRow,
    isECoverCrossSellingItemRow,
    isGearOilCrossSellingItemRow,
} from '../../part-table/part-table.helper';
import { PartRow } from '../../part-table/part-table.interface';

export const isCrossSellingItem = (row: PartRow) =>
    isGearOilCrossSellingItemRow(row) || isECoverCrossSellingItemRow(row) || isCableCrossSellingItemRow(row);
